<div class="page-wrapper">
    <div class="overview-container">
        <div class="overview-wrapper">
            <div *ngFor="let eap of eapArray; index as i">
                <app-eap-status-indicator
                    [isReceivingData]="isReceivingData"
                    [index]="i"
                    [eap]="eap"
                ></app-eap-status-indicator>
            </div>
        </div>
    </div>
</div>
